module.exports = __webpack_public_path__ + "img/single-white.be949ff8.png";